import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { menu } from './MenuList';
import { FaBars } from "react-icons/fa6";

import logo from './../../assets/images/static/logo.png';
import LoginModal from './../Modal/LoginModal';

import {
  StyledNavbar,
  Wrapper,
  StyledLogo,
  Img,
  StyledList,
  Li,
  AccountSection,
  MenuOption,
  LoginButton,
  SignUpButton,
} from './styled';

const Navbar = () => {

  const [showSignUp, setSignUpModal] = useState(false);
  const [isNavExpanded, setIsNavExpanded] = useState(false);

  return (
    <>
      <StyledNavbar>
        <Wrapper>
          <StyledLogo>
            <Link to="/"><Img src={logo} alt='Electronic Retail Point' /></Link>
          </StyledLogo>
          <StyledList 
            className={isNavExpanded ? "hideonMobile toggleMenu hidden" : "hideonMobile hidden"}
          >
            {
              menu.map((list) => (
                <Li key={list.id}>
                  <HashLink 
                    to={list.redirect} 
                  >
                    {list.title}
                  </HashLink>
                </Li>
              ))
            }
          </StyledList>
          <AccountSection 
            // className={isNavExpanded ? "hideonMobile toggleMenu" : "hideonMobile"}
          >
            <LoginButton>
              <Link to="https://app.prod.eretailpoint.com/auth/login" target='_blank'>Log in</Link>
            </LoginButton>
            <SignUpButton 
              onClick={() => setSignUpModal(true)}>
              Sign Up <span>for Free</span>
            </SignUpButton>
          </AccountSection>
          <MenuOption 
            className='showonMobile hidden'
            onClick={() => {
            setIsNavExpanded(!isNavExpanded);
          }}
          >
            <FaBars />
          </MenuOption>
        </Wrapper>
      </StyledNavbar>
      { showSignUp && <LoginModal closeModal={setSignUpModal} /> }
    </>
  );
}

export default Navbar;